var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        [
          _c("oaFromBox", {
            attrs: {
              isAddBtn: false,
              search: _vm.search,
              total: _vm.total,
              isViewSearch: false,
            },
            on: { confirmData: _vm.confirmData },
          }),
          _vm._v(" "),
          _vm.tableData.length > 0
            ? _c("div", { staticClass: "mt-10" }, [
                _c(
                  "div",
                  [
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.tableData,
                          "row-key": "id",
                          loading: _vm.loading,
                          "default-expand-all": "",
                          height: _vm.tableHeight,
                          "tree-props": { children: "children" },
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "name",
                            label: _vm.$t("user.work.assessmentname"),
                            "min-width": "130",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "period",
                            label: _vm.$t("toptable.assessmentcycle"),
                            "min-width": "100",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getPeriodText(scope.row.period)
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2162295436
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "score",
                            label: _vm.$t("user.work.qssessmentscore"),
                            "min-width": "100",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "level",
                            label: _vm.$t("access.assessmentgrade"),
                            "min-width": "100",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "check.name",
                            label: _vm.$t("user.work.assessor"),
                            "min-width": "100",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "status",
                            label: _vm.$t("hr.assessmentstatus"),
                            "min-width": "120",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: _vm.getStatusTag(
                                            scope.row.status
                                          ).type,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getStatusTag(scope.row.status)
                                              .text
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1560801133
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "start_time",
                            label: _vm.$t("access.starttime"),
                            "min-width": "100",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm
                                            .$moment(scope.row.start_time)
                                            .format("yyyy-MM-DD")
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            341604558
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "end_time",
                            label: _vm.$t("access.endtime"),
                            "min-width": "100",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm
                                            .$moment(scope.row.end_time)
                                            .format("yyyy-MM-DD")
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            188710177
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "address",
                            label: _vm.$t("public.operation"),
                            fixed: "right",
                            width: "240",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.status !== 1
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleCheck(
                                                  scope.row,
                                                  "check"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                查看\n              "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    scope.row.status > 0 && scope.row.status < 5
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleCheck(
                                                  scope.row,
                                                  "selfEdit"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  scope.row.status === 1
                                                    ? "自评"
                                                    : "修改自评"
                                                ) +
                                                "\n              "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    scope.row.status !== 0 &&
                                    scope.row.status !== 1
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleScore(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("access.scoringrecord")
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            380573495
                          ),
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "page-fixed" },
                      [
                        _c("el-pagination", {
                          attrs: {
                            "page-size": _vm.where.limit,
                            "current-page": _vm.where.page,
                            "page-sizes": [15, 20, 30],
                            layout: "total,sizes, prev, pager, next, jumper",
                            total: _vm.total,
                          },
                          on: {
                            "size-change": _vm.handleSizeChange,
                            "current-change": _vm.pageChange,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _c("default-page", { attrs: { index: 0, "min-height": 420 } }),
        ],
        1
      ),
      _vm._v(" "),
      _c("score-dialog", { ref: "scoreDialog", attrs: { config: _vm.config } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }